'use strict';

(function () {
  angular.module('specsguardApp')
    .factory('PvETemplateAPI', PvETemplateApi);

  PvETemplateApi.$inject = ['$resource'];

  function PvETemplateApi ($resource) {
    return $resource('/api/pvetemplate/:id', {
      id: '@id'
    }, {
      update: {
        method: 'PATCH'
      },
      copy: {
        method: 'POST'
      }
    });
  }
})();
